export default __webpack_public_path__ + "static/media/logo (1).6cefd983.svg";